module.exports = __webpack_public_path__ + "fonts/OpenSans-Bold.5487bea9.eot";